import React from 'react'
import { VotePageContainer } from '../'
import { SingleReportContainer } from '../SingleReport'
import { loadReportsById } from 'lib/api/rideReports'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { VOTING_ACTIVE } from 'lib/utils'
const history = window.history

export class VotePageRouter extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      reportId: (history.state && history.state.reportId) || null
    }
  }

  componentDidMount () {
    if (!VOTING_ACTIVE) {
      browserHistory.push('/ride_reports/')
      return
    }
    window.addEventListener('popstate', this.onPopState)

    // more efficient code for when we only have 10 finalists:
    // const {finalistIds, loadReportsById, reports} = this.props
    // const missingIds = finalistIds.filter(id => !reports.has(id))
    // if (missingIds.length > 0) {
    //   loadReportsById(missingIds)
    // }
    this.loadAllReports()
  }

  loadAllReports = () => {
    const { finalistIds, loadReportsById } = this.props

    for (let i = 0; i < Math.ceil(finalistIds.length / 20); i++) {
      const slice = finalistIds.slice(20 * i, 20 * i + 20)
      loadReportsById(slice)
    }
  }

  onChangeRoute = (reportId) => {
    // title is ignored by current implementations. Weird.
    history.pushState({ reportId }, '', window.location.href)
    this.setState({ reportId }, () => window.scrollTo(0, 0))
  }

  onPopState = (e) => {
    const reportId = (e.state && e.state.reportId) || null
    this.setState({ reportId }, () => window.scrollTo(0, 0))
  }

  render () {
    const { reportId } = this.state
    if (reportId) {
      return <SingleReportContainer reportId={reportId} onChangeRoute={this.onChangeRoute} />
    }
    return <VotePageContainer onChangeRoute={this.onChangeRoute} />
  }
}

const mapStateToProps = (state) => ({
  reports: state.rideReports.reports,
  finalistIds: state.rolloutContest.finalistIds
})

const mapDispatchToProps = {
  loadReportsById
}

export const VotePageRouterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(VotePageRouter)
